// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"760fb7a0","513":"017e5de3","703":"bbf19e7c","787":"b520555d"}[chunkId] + ".chunk.js";
};